import {TitleLabel} from "../../checkout/components/components";
import {Field} from "react-final-form";
import {required} from "src/core/common/validations";
import {
  FieldContainer,
  FormFields,
} from "src/core/common/components/collections/form/forms";
import Input from "../../common/components/elements/input/Input";
import Error from "../../common/components/elements/Error";
import React from "react";
import styled from "styled-components";
import useFormsCache from "src/core/common/hooks/useFormsCache";
import curry from "lodash/curry";
import useFeatureToggles from "../../common/hooks/useFeatureToggles";
import {useForm} from "src/core/common/components/FormContext";
import {showErrorHighlight} from "src/core/common/utils";

function PersonalInfoSection({
  style,
  title,
  titleComponent,
  showAsDisabled,
  disabled,
  className,
  children,
  user,
  onClickDisabledField,
}) {
  const toggles = useFeatureToggles();
  const [firstNameValue, setFirstNameValue] = useFormsCache(FormFields.FIRST_NAME);
  const [lastNameValue, setLastNameValue] = useFormsCache(FormFields.LAST_NAME);
  const formContext = useForm();
  const _disabled = formContext.disabled || disabled;

  const onChangeFirstName = curry((callback, evt) => {
    const value = evt.target.value;
    !toggles.isKiosk() && setFirstNameValue(value);
    callback(value);
  });

  const onChangeLastName = curry((callback, evt) => {
    const value = evt.target.value;
    !toggles.isKiosk() && setLastNameValue(value);
    callback(value);
  });

  return (
    <Section style={style} className={className} id={"personal-info-section"}>
      {title && <TitleLabel>{title}</TitleLabel>}
      {titleComponent}
      <HorizontalGroup>
        <Field
          name="firstName"
          validate={required}
          initialValue={(user && user.getFirstName()) || firstNameValue}
          render={({input, meta}) => (
            <FieldContainer
              onClick={!_disabled && showAsDisabled ? onClickDisabledField : undefined}
            >
              <Input
                {...input}
                data-cy="expressCheckoutFirstNameField"
                index={5}
                disabled={disabled || showAsDisabled}
                className={meta.error ? "invalid" : ""}
                placeholder={"First Name*"}
                hasErrors={showErrorHighlight(meta)}
                onChange={onChangeFirstName(input.onChange)}
              />
              {meta.touched && <Error>{meta.error}</Error>}
            </FieldContainer>
          )}
        />
        <Field
          name="lastName"
          initialValue={(user && user.getLastName()) || lastNameValue}
          render={({input, meta}) => (
            <FieldContainer
              onClick={!_disabled && showAsDisabled ? onClickDisabledField : undefined}
            >
              <Input
                {...input}
                data-cy="expressCheckoutLastNameField"
                index={6}
                disabled={disabled || showAsDisabled}
                className={meta.error ? "invalid" : ""}
                placeholder={"Last Name*"}
                hasErrors={showErrorHighlight(meta)}
                onChange={onChangeLastName(input.onChange)}
              />
              {meta.touched && <Error>{meta.error}</Error>}
            </FieldContainer>
          )}
        />
      </HorizontalGroup>
      {children}
    </Section>
  );
}

const HorizontalGroup = styled.div`
  display: flex;
  flex-direction: row;

  > *:not(:last-child) {
    margin-right: ${({theme}) => theme.v2.spacing(2)};
  }
`;

const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${({theme}) => theme.v2.spacing(8)} 0;
  row-gap: 10px;
`;

export default PersonalInfoSection;
